import { useEffect, useState } from 'react';
import { getCurrentMonthKey } from '../viewmodels/parity/monthScope';

// Date-based state must also advance without navigation. Local midnight handles
// DST; focus/visibility handles a browser that suspended the timer while asleep.
export default function useCurrentMonthKey() {
  const [month, setMonth] = useState(getCurrentMonthKey);
  useEffect(() => {
    let timer;
    const sync = () => {
      window.clearTimeout(timer);
      setMonth(getCurrentMonthKey());
      const now = new Date();
      const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      timer = window.setTimeout(sync, Math.max(1, tomorrow.getTime() - now.getTime()));
    };
    sync();
    window.addEventListener('focus', sync);
    document.addEventListener('visibilitychange', sync);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener('focus', sync);
      document.removeEventListener('visibilitychange', sync);
    };
  }, []);
  return month;
}
